// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__BE0_I","header":"ClearentDisclaimer_header__2Wpel","inner":"ClearentDisclaimer_inner__2RZHE"};